/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {RelatedFiles} from '../../core/_models'

type Props = {
  RelatedFiles: RelatedFiles
}

const RelatedFilesDescription: FC<Props> = ({RelatedFiles}) => (
  <div className='d-flex text-center justify-content-center'>
    <div className='d-flex flex-column'>
      <a
        href={RelatedFiles.url}
        className='border border-gray-100 rounded text-white bg-success px-2 py-1'
        target='_blank'
        rel='noreferrer'
      >
        {RelatedFiles.description}
      </a>
    </div>
  </div>
)

export {RelatedFilesDescription}
